module.exports = {
  ARTICLE_LIST: 'articleList',
  ARTICLE_SET: 'articleSet',
  ARTICLE_GET: 'articleGet',
  ARTICLE_CREATE: 'articleCreate',
  ARTICLE_REMOVE: 'articleRemove',
  ARTICLE_RESET: 'articleReset',
  ARTICLE_UPDATE: 'articleUpdate',
  ARTICLE_COMMENT: 'createComment',
  ARTICLE_UPDATE_COMMENT: 'updateComment',
  ARTICLE_DELETE_COMMENT: 'deleteComment',
  ARTICLE_REPLY: 'createReply',
  ARTICLE_UPDATE_REPLY: 'updateReply',
  ARTICLE_DELETE_REPLY: 'deleteReply'
}
